import React, { useEffect } from "react";
import PageShell from "@/components/PageShell";
import AppStoreButtons from "@/components/AppStoreButtons";
import ScreenCarousel from "@/components/ScreenCarousel";
import { PhoneTrio } from "@/components/PhoneFrame";
import { APP_GROUND, TRIO_BOX, AppPrice } from "@/components/AppShowcase";
import { dharmaApp } from "@/data/app";
import { trackEvent } from "@/lib/tracking";

export default function DharmaApp() {
  const a = dharmaApp;
  useEffect(() => {
    trackEvent("app_page_view", { title_id: "dharma-app", slug: "dharma-app" });
  }, []);

  return (
    <PageShell title={a.name} paddingTop={false}>
      {/* Room for the fixed header, and no more: the hero starts right under it. */}
      <div className="h-[60px] md:h-[72px]" aria-hidden="true" />

      {/* Hero */}
      <section className="text-cream overflow-hidden" style={APP_GROUND}>
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 pt-7 md:pt-14 pb-12 md:pb-20 lg:py-16 xl:py-20 grid grid-cols-1 lg:grid-cols-12 gap-7 lg:gap-6 items-center">
          <div className="lg:col-span-5 md:text-center lg:text-left">
            <div className="flex items-center gap-4 mb-4 md:mb-6 md:justify-center lg:justify-start">
              <img
                src={a.icon}
                alt=""
                width="64"
                height="64"
                className="w-11 h-11 md:w-16 md:h-16 rounded-xl md:rounded-2xl shadow-lg"
              />
              <p className="eyebrow !text-dawn-rose !mb-0">The app</p>
            </div>
            <h1 className="font-display text-4xl md:text-6xl lg:text-5xl xl:text-6xl leading-[1.04] tracking-tightish text-cream text-balance">
              {a.name}
            </h1>
            <p className="font-serif text-[17px] md:text-2xl lg:text-xl xl:text-2xl text-cream/80 mt-4 md:mt-6 leading-snug md:leading-relaxed max-w-xl md:mx-auto lg:mx-0">
              {a.tagline}
            </p>
            <AppPrice className="text-dawn-rose mt-5 md:mt-7" />
            <AppStoreButtons
              placement="page-hero"
              tone="dark"
              className="mt-5 md:mt-7 md:justify-center lg:justify-start"
            />
          </div>
          <div className="lg:col-span-7">
            <PhoneTrio screens={a.trio} eager className={TRIO_BOX} />
          </div>
        </div>
      </section>

      {/* Screens, room by room */}
      <section className="bg-cream pt-12 md:pt-20 pb-4 md:pb-8">
        <div className="max-w-8xl mx-auto">
          <div className="px-5 md:px-10 lg:px-14 max-w-3xl mb-7 md:mb-10">
            <div className="eyebrow mb-4">Inside the app</div>
            <h2 className="font-display text-3xl md:text-5xl text-ink leading-[1.1] tracking-tightish">
              A temple, a daily darshan, a practice and a library
            </h2>
          </div>
          <ScreenCarousel screens={a.screens} rooms={a.rooms} />
        </div>
      </section>

      {/* The four rooms in words */}
      <section className="bg-cream pt-10 md:pt-14 pb-16 md:pb-24">
        <div className="max-w-8xl mx-auto px-5 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-x-10 gap-y-8 md:gap-y-12">
            {a.rooms.map((r) => (
              <div key={r.id} className="border-t border-dharma-gold/30 pt-5">
                <div className="eyebrow mb-3">{r.label}</div>
                <h3 className="font-display text-xl md:text-2xl text-ink leading-tight tracking-tightish">
                  {r.title}
                </h3>
                <p className="font-serif text-[17px] md:text-lg text-ink-soft mt-3 leading-normal md:leading-relaxed">
                  {r.body}
                </p>
              </div>
            ))}
          </div>
          <p className="font-serif italic text-[17px] md:text-xl text-ink-soft mt-10 md:mt-16 max-w-3xl leading-normal md:leading-relaxed">
            {a.also}
          </p>
        </div>
      </section>

      {/* Close. -mb-20 meets the footer's own top margin, so no cream stripe is left between them. */}
      <section className="bg-parchment/40 py-14 md:py-24 border-t border-dharma-gold/15 -mb-20">
        <div className="max-w-2xl mx-auto px-5 md:px-10 text-center">
          <img src={a.icon} alt="" width="72" height="72" className="w-[72px] h-[72px] rounded-2xl mx-auto shadow-md" />
          <h3 className="font-display text-3xl md:text-4xl text-ink leading-tight tracking-tightish mt-6">
            {a.short}
          </h3>
          <AppPrice className="text-dharma-gold-deep mt-4" />
          <AppStoreButtons placement="page-foot" className="mt-7 mx-auto justify-center" />
        </div>
      </section>
    </PageShell>
  );
}
